// import { Link, useLocation } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux";
// import { useEffect, useRef, useState } from "react";
// import { base_url } from "../components/config";
// import { useNavigate } from "react-router-dom";
// import { useTranslate } from '../hooks/useTranslate';

// function Header({ data = [], site_settings = [] }) {
//   const __ = useTranslate();
//   const { isAuthenticated, user } = useSelector(state => state.auth);
// const navigate = useNavigate();

//   const cart = useSelector(state => state.home.common_data?.cart || { products: [] });
// const wishlist = useSelector(
//   state => state.home.common_data?.wishlist || { products: [], count: 0 }
// );


//   const closeBtnRef = useRef(null);

//   const handleLinkClick = () => {
//     if (closeBtnRef.current) {
//       closeBtnRef.current.click();
//     }
//   };
//   const [isOpen, setIsOpen] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     setIsOpen(false);
//   }, [location]);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     dispatch({ type: 'CCheckAuth_sync' });
//   }, [dispatch]);

//   const handleRemove = (item) => {
//     dispatch({
//       type: "CCart_remove",
//       data: {
//         product_id: item.id,
//         id_product_attribute: item.id_product_attribute ?? null,
//         id_customization: item.id_customization ?? 0,
//       }
//     });
//   };
//   const handleLogout = () => {
//     dispatch({ type: 'CLogout_sync' });
//   };
//   const [query, setQuery] = useState("");
//   const [results, setResults] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (query.length < 2) {
//       setResults([]);
//       return;
//     }

//     const timeout = setTimeout(async () => {
//       setLoading(true);

//       try {
//         const res = await fetch(
//           `${base_url}ps_checkoutapi/api/?action=search&q=${encodeURIComponent(query)}`,
//           { credentials: "include" }
//         );
//         const data = await res.json();
//         setResults(data.products || []);
//       } catch (err) {
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     }, 300);

//     return () => clearTimeout(timeout);
//   }, [query]);

// const handleSearchSubmit = (e) => {
//   e.preventDefault();
//   if (!query) return;

//   setIsOpen(false);
//         if (closeBtnRef.current) {
//         closeBtnRef.current.click();
//       }
//   navigate({
//     pathname: "/shop",
//     search: `?search=${encodeURIComponent(query)}`,
//   });

// };
//   const searchRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (searchRef.current && !searchRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//     useEffect(() => {
//     const $document = jQuery(document);

//     $document.on('click', '.careerFilterInr li a', function (e) {
//       e.preventDefault();
//       e.stopPropagation();

//       const $childOption = jQuery(this).closest('.child_option');
//       const $button = $childOption.find('button').first();
//       const text = jQuery(this).text();
//       let val = jQuery(this).attr('value') || text;

//       $button.text(text);

//       $childOption.find('.dropdown-menu2').slideUp('fast');
//       $childOption.find('.open-menu2').removeClass('active');
//     });

//     $document.on('click', '.careerFilter .child_option > .open-menu2', function (e) {
//       e.stopPropagation();

//       const $toggle = jQuery(this);
//       const $menu = $toggle.siblings('.dropdown-menu2');

//       if ($toggle.hasClass('active')) {
//         $menu.slideUp('fast');
//         $toggle.removeClass('active');
//       } else {
//         jQuery('.dropdown-menu2').slideUp('fast');
//         jQuery('.open-menu2').removeClass('active');

//         $menu.slideDown('fast');
//         $toggle.addClass('active');
//       }
//     });

//     $document.on('click', function () {
//       jQuery('.dropdown-menu2').slideUp('fast');
//       jQuery('.open-menu2').removeClass('active');
//     });

//     return () => {
//       $document.off('click', '.careerFilterInr li a');
//       $document.off('click', '.careerFilter .child_option > .open-menu2');
//       $document.off('click');
//     };
//   }, []);
//   return (

//     <>
//       <div className="offcanvas offcanvas-end" id="mainMenu">
//         <div className="offcanvas-body">
//           <div className="d-flex align-items-center justify-content-between">
//             <a className="logo d-block" href="index.html">
//               {site_settings.head_logo && (
//                 // <img
//                 //   src={site_settings.head_logo}
//                 //   alt="Logo"
//                 //   className="w-100"
//                 // />
//                                     <svg xmlns="http://www.w3.org/2000/svg" width="138" height="48" viewBox="0 0 138 48" fill="none">
// <path d="M33.3087 6.42846C32.7364 5.94573 32.0912 5.55688 31.3971 5.2766C30.8093 5.03768 30.1821 4.91115 29.5475 4.9038C28.8874 4.8736 28.2359 5.06163 27.6933 5.43905C27.2354 5.75878 26.9668 6.2856 26.9766 6.84398C26.9627 7.20643 27.0911 7.55991 27.335 7.82849C27.6068 8.11312 27.9314 8.34196 28.2906 8.50224C28.7135 8.70088 29.1535 8.86061 29.6049 8.98034C30.0828 9.11885 30.5606 9.27178 31.0387 9.42933C32.95 10.0666 34.3487 10.9173 35.2344 11.9815C36.1629 13.1663 36.6361 14.6447 36.5678 16.1486C36.5825 17.2219 36.3844 18.2875 35.9847 19.2837C35.6034 20.1985 35.0203 21.0151 34.2785 21.6731C33.4774 22.3716 32.5427 22.9001 31.531 23.2261C30.341 23.6095 29.0964 23.7951 27.8463 23.7757C25.0065 23.7782 22.2372 22.8908 19.9277 21.238L22.4366 16.5165C23.2086 17.2251 24.0856 17.8104 25.0361 18.2513C25.8329 18.6167 26.6977 18.8105 27.5739 18.82C28.3442 18.8809 29.1083 18.645 29.7102 18.1604C30.1486 17.7881 30.4047 17.2445 30.4126 16.6695C30.4207 16.3653 30.3603 16.0632 30.2357 15.7854C30.0945 15.513 29.8896 15.2787 29.6384 15.1021C29.301 14.8605 28.9328 14.6645 28.544 14.519C28.0996 14.3375 27.5548 14.1415 26.9192 13.9217C26.1578 13.6827 25.4152 13.4183 24.6922 13.1285C23.9871 12.8523 23.3319 12.4634 22.7517 11.9766C22.1689 11.4803 21.6995 10.8642 21.3757 10.1703C21.0007 9.29899 20.823 8.35584 20.8546 7.40807C20.841 6.37159 21.0293 5.34245 21.4091 4.37808C21.7572 3.50024 22.2864 2.70566 22.9621 2.04606C23.6633 1.37856 24.4971 0.865627 25.4089 0.540723C26.4484 0.169015 27.5456 -0.0141177 28.6493 0.000848535C29.8305 0.0152706 31.0055 0.175818 32.1473 0.478681C33.3623 0.788619 34.5351 1.24441 35.6407 1.83571L33.3087 6.40914V6.42846Z" fill="#1C1C1C"/>
// <path d="M46.3934 0.660645V12.909C46.3934 13.5638 46.3934 14.2375 46.465 14.9257C46.5058 15.5681 46.6576 16.1989 46.9142 16.7894C47.1651 17.3497 47.5757 17.8234 48.0946 18.1513C48.7864 18.5372 49.5736 18.7179 50.3646 18.6724C51.1508 18.72 51.9342 18.5391 52.6202 18.1513C53.1342 17.8177 53.5432 17.3456 53.8006 16.7894C54.0714 16.2022 54.2333 15.5706 54.2784 14.9257C54.3261 14.2375 54.35 13.5638 54.35 12.909V0.660645H60.1567V13.7406C60.1567 17.2449 59.3602 19.8033 57.7672 21.4153C56.174 23.0276 53.71 23.8336 50.3741 23.8336C47.0481 23.8336 44.5789 23.0276 42.9669 21.4153C41.3547 19.8033 40.5535 17.2449 40.5631 13.7406V0.660645H46.3934Z" fill="#1C1C1C"/>
// <path d="M71.0335 23.1835H65.1792V0.660645H74.4934C77.02 0.660645 78.9569 1.31862 80.3044 2.63429C81.6522 3.95023 82.3243 5.80115 82.3213 8.18732C82.3213 10.5768 81.6489 12.4296 80.3044 13.7453C78.9602 15.0612 77.023 15.7173 74.4934 15.7143H71.0286V23.1835H71.0335ZM71.0335 10.9974H72.9736C75.1242 10.9974 76.1993 10.0608 76.1996 8.18732C76.1993 6.31409 75.1242 5.3791 72.9736 5.3821H71.0335V10.9974Z" fill="#1C1C1C"/>
// <path d="M98.5407 5.62129H91.5828V9.38218H98.1538V14.3425H91.5828V18.2232H98.5407V23.1835H85.7285V0.660645H98.5407V5.62129Z" fill="#1C1C1C"/>
// <path d="M121.804 23.1829H114.493L108.901 14.5188V23.1829H103.047V0.660021H112.156C113.277 0.637436 114.392 0.825467 115.444 1.21432C116.317 1.54031 117.107 2.05624 117.757 2.72455C118.362 3.35803 118.831 4.10961 119.133 4.93221C119.45 5.794 119.611 6.70477 119.611 7.62288C119.679 9.11243 119.241 10.5808 118.368 11.79C117.442 12.919 116.148 13.6853 114.713 13.955L121.804 23.1829ZM108.901 10.7291H110.005C110.947 10.7887 111.883 10.5369 112.667 10.0123C113.806 8.99352 113.903 7.2441 112.884 6.1053C112.816 6.02883 112.744 5.95645 112.667 5.88815C111.883 5.36351 110.947 5.11181 110.005 5.1714H108.901V10.7291Z" fill="#1C1C1C"/>
// <path d="M11.9627 34.5331H23.5801C23.5861 35.6196 23.5365 36.7059 23.432 37.7876C23.3441 38.7147 23.1433 39.6279 22.8347 40.5065C22.4437 41.6336 21.869 42.6881 21.1332 43.6274C20.4276 44.5221 19.5743 45.2898 18.6102 45.8974C17.6235 46.5143 16.5511 46.9812 15.4273 47.2833C14.2408 47.6068 13.0158 47.7676 11.7858 47.7611C10.152 47.781 8.52998 47.4874 7.00695 46.896C5.61155 46.3535 4.34513 45.5249 3.28878 44.4636C2.23135 43.388 1.40657 42.106 0.86588 40.6978C0.272944 39.1503 -0.0203955 37.5043 0.00110147 35.8471C-0.0182186 34.1995 0.26995 32.5624 0.85173 31.0206C1.3848 29.6152 2.20876 28.3384 3.26974 27.2739C4.35003 26.2167 5.63713 25.3933 7.04995 24.8559C8.62304 24.2589 10.2946 23.9636 11.9771 23.9862C14.1366 23.9399 16.2703 24.4659 18.1609 25.5106C20.0156 26.6148 21.4856 28.2633 22.3711 30.232L16.818 32.5306C16.4278 31.4625 15.7252 30.5368 14.8014 29.8737C13.9608 29.3303 12.9777 29.0492 11.9771 29.066C11.1553 29.0497 10.3398 29.2127 9.58768 29.5439C8.87801 29.8682 8.25079 30.3485 7.75255 30.9488C7.22056 31.5989 6.81538 32.3431 6.55769 33.1423C6.25619 34.0678 6.10925 35.0365 6.12285 36.0098C6.11496 36.9089 6.24041 37.8044 6.49565 38.6668C6.72368 39.4423 7.10546 40.1639 7.61866 40.7887C8.11936 41.3887 8.75256 41.8647 9.46823 42.1792C10.2818 42.5183 11.1581 42.681 12.0392 42.657C12.6024 42.6579 13.1638 42.592 13.7118 42.4611C14.2226 42.3381 14.7078 42.1264 15.1453 41.8353C15.5756 41.5433 15.9375 41.1618 16.2063 40.7169C16.504 40.2026 16.6956 39.6339 16.7701 39.0442H11.9627V34.5042V34.5331Z" fill="#1C1C1C"/>
// <path d="M39.2492 43.2209H30.8864L29.5435 47.1347H23.2974L31.8706 24.6167H38.2647L46.8333 47.1347H40.5921L39.2492 43.2209ZM37.6963 38.7715L35.0679 31.2734L32.4393 38.7715H37.6963Z" fill="#1C1C1C"/>
// <path d="M55.2583 24.6123V42.1748H62.2786V47.1352H49.4043V24.6123H55.2583Z" fill="#1C1C1C"/>
// <path d="M71.1479 24.6123V42.1748H78.1682V47.1352H65.2939V24.6123H71.1479Z" fill="#1C1C1C"/>
// <path d="M93.9958 29.5727H87.0376V33.3338H93.6086V38.2942H87.0376V42.1748H93.9958V47.1352H81.1836V24.6123H93.9958V29.5727Z" fill="#1C1C1C"/>
// <path d="M116.949 47.1347H109.647L104.065 38.4755V47.1347H98.2061V24.6167H107.319C108.439 24.5931 109.552 24.7795 110.602 25.1664C112.322 25.798 113.674 27.1597 114.292 28.8843C114.611 29.7453 114.773 30.6566 114.77 31.5747C114.837 33.0634 114.401 34.5312 113.532 35.7419C112.602 36.8692 111.307 37.6352 109.871 37.9068L116.949 47.1347ZM104.065 34.6809H105.169C106.11 34.7421 107.044 34.4899 107.826 33.9641C108.965 32.9532 109.069 31.2103 108.057 30.0713C107.985 29.9896 107.908 29.9124 107.826 29.84C107.044 29.3143 106.11 29.062 105.169 29.1232H104.065V34.6809Z" fill="#1C1C1C"/>
// <path d="M123.745 36.3206L115.535 24.6123H122.521L126.703 30.7675L130.856 24.6123H137.843L129.599 36.3206V47.1352H123.745V36.3206Z" fill="#1C1C1C"/>
// </svg>
//               )}
//             </a>
//             <button
//               type="button"
//               className="btn-close"
//               data-bs-dismiss="offcanvas"
//               aria-label="Close"
//               ref={closeBtnRef}
//             ></button>
//           </div>

//           {/* Menu Links */}
//           <div className="menu-wrap">
//             <ul className="d-lg-flex align-items-center">
//               {(data || []).map((item) => (
//                 <li key={item.id_custom_menu}>
//                   <Link to={item.link} className="link" onClick={handleLinkClick}>{item.title}</Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <div className="right-wrap d-lg-flex align-items-center justify-content-between position-relative">
// <div className="header-search">
//       <form
//         ref={searchRef}
//         onSubmit={handleSearchSubmit}
//       >
//         <div className="form-group mb-0">
//           <input
//             type="text"
//             name="search"
//             placeholder={__("Search for a photographer")}
//             required
//             className="form-control"
//             autoComplete="off"
//             value={query}
//             onChange={(e) => {
//               setQuery(e.target.value);
//               setIsOpen(true);
//             }}
//           />
//           <svg onClick={handleSearchSubmit}
//             width="20"
//             height="20"
//             viewBox="0 0 20 20"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
//               stroke="#1C1C1C"
//               strokeWidth="1.5"
//               strokeLinecap="square"
//             />
//           </svg>
//         </div>
//       </form>

//       {/* Suggestions Dropdown */}
//       {isOpen && (loading || results.length > 0 || query.length > 1) && (
//         <div
//           className="position-absolute suggestions w-100 shadow-sm"
//           onMouseDown={(e) => e.preventDefault()} // prevent input blur from closing dropdown
//         >
//           {loading && (
//             <div className="text-center p-3 text-muted">Searching...</div>
//           )}

//           {!loading && results.length === 0 && query.length > 1 && (
//             <div className="text-center p-3 text-muted">No results found</div>
//           )}

//           {!loading && results.length > 0 && (
//             <ul className="list-unstyled mb-0">
//               {results.map((item) => (
// <li key={item.id}>
//   <div
//     className="row align-items-center"
//     style={{ cursor: "pointer" }}
//     onMouseDown={(e) => {
//       e.preventDefault();
//       navigate(`/product/${item.slug}`);
//       setIsOpen(false);

//       // close the offcanvas
//       if (closeBtnRef.current) {
//         closeBtnRef.current.click();
//       }
//     }}
//   >
//     <div className="col-4 col-md-4">
//       <figure className="p-0 m-0">
//         <img src={item.image} alt={item.name} className="w-100" />
//       </figure>
//     </div>

//     <div className="col-8 col-md-8">
//       <article className="d-flex justify-content-between align-items-start flex-wrap flex-md-nowrap">
//         <span className="text-dark">{item.name}</span>
//       </article>
//     </div>
//   </div>
// </li>


//               ))}
//             </ul>
//           )}
//         </div>
//       )}
//     </div>


// {/* <div className="head-btn mt-3">
//   {site_settings.languages && site_settings.languages.map((lang) => (
//     <a 
//       key={lang.id_lang}
//       href="#" 
//       className={`btn ${Number(site_settings.currentLangId) === Number(lang.id_lang) ? 'active' : ''}`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   const payload = { lang_id: lang.id_lang };

//                   dispatch({ type: 'CcommonContent_sync', payload: payload });
//                   dispatch({ type: 'Chome_sync', payload: payload });
//                   dispatch({ type: 'CContactPage_sync', payload: payload });
//                   dispatch({ type: 'CDataProtectionPage_sync', payload: payload });
//                   dispatch({ type: 'CTermsConditionsPage_sync', payload: payload });
//                   dispatch({ type: 'CGalleryCollectionPage_sync', payload: payload });
//                   dispatch({ type: 'CFramesPage_sync', payload: payload });
//                   dispatch({ type: 'CQualityPrintsPage_sync', payload: payload });
//                   dispatch({ type: 'COurLabsPage_sync', payload: payload });
//                   dispatch({ type: 'Cproducts_sync', payload: payload });
//                 }}
//     >
//       {lang.name}
//     </a>
//   ))}
// </div> */}
//           </div>
//         </div>
//       </div>

//       <header className="header">
//         <div className="container">
//           <div className="row align-items-center justify-content-between">
//             <div className="col-md-5 d-none d-lg-block">
//               <div className="menu-wrap d-flex">
//                 <ul className="d-flex align-items-center">
//                   {(data || []).map((item) => (
//                     <li key={item.id_custom_menu}>
//                       <Link to={item.link} className="link">{item.title}</Link>
//                     </li>
//                   ))}
//                 </ul>

//               </div>
//             </div>

//             <div className="col-4 col-lg-2">
//               <div className="headerlogo">

//                 <Link className="logo d-block" to="/">
//                   {site_settings.head_logo && (
//                     // <img src={site_settings.head_logo} alt="Logo" className="w-100" />
//                     <svg xmlns="http://www.w3.org/2000/svg" width="138" height="48" viewBox="0 0 138 48" fill="none">
// <path d="M33.3087 6.42846C32.7364 5.94573 32.0912 5.55688 31.3971 5.2766C30.8093 5.03768 30.1821 4.91115 29.5475 4.9038C28.8874 4.8736 28.2359 5.06163 27.6933 5.43905C27.2354 5.75878 26.9668 6.2856 26.9766 6.84398C26.9627 7.20643 27.0911 7.55991 27.335 7.82849C27.6068 8.11312 27.9314 8.34196 28.2906 8.50224C28.7135 8.70088 29.1535 8.86061 29.6049 8.98034C30.0828 9.11885 30.5606 9.27178 31.0387 9.42933C32.95 10.0666 34.3487 10.9173 35.2344 11.9815C36.1629 13.1663 36.6361 14.6447 36.5678 16.1486C36.5825 17.2219 36.3844 18.2875 35.9847 19.2837C35.6034 20.1985 35.0203 21.0151 34.2785 21.6731C33.4774 22.3716 32.5427 22.9001 31.531 23.2261C30.341 23.6095 29.0964 23.7951 27.8463 23.7757C25.0065 23.7782 22.2372 22.8908 19.9277 21.238L22.4366 16.5165C23.2086 17.2251 24.0856 17.8104 25.0361 18.2513C25.8329 18.6167 26.6977 18.8105 27.5739 18.82C28.3442 18.8809 29.1083 18.645 29.7102 18.1604C30.1486 17.7881 30.4047 17.2445 30.4126 16.6695C30.4207 16.3653 30.3603 16.0632 30.2357 15.7854C30.0945 15.513 29.8896 15.2787 29.6384 15.1021C29.301 14.8605 28.9328 14.6645 28.544 14.519C28.0996 14.3375 27.5548 14.1415 26.9192 13.9217C26.1578 13.6827 25.4152 13.4183 24.6922 13.1285C23.9871 12.8523 23.3319 12.4634 22.7517 11.9766C22.1689 11.4803 21.6995 10.8642 21.3757 10.1703C21.0007 9.29899 20.823 8.35584 20.8546 7.40807C20.841 6.37159 21.0293 5.34245 21.4091 4.37808C21.7572 3.50024 22.2864 2.70566 22.9621 2.04606C23.6633 1.37856 24.4971 0.865627 25.4089 0.540723C26.4484 0.169015 27.5456 -0.0141177 28.6493 0.000848535C29.8305 0.0152706 31.0055 0.175818 32.1473 0.478681C33.3623 0.788619 34.5351 1.24441 35.6407 1.83571L33.3087 6.40914V6.42846Z" fill="#1C1C1C"/>
// <path d="M46.3934 0.660645V12.909C46.3934 13.5638 46.3934 14.2375 46.465 14.9257C46.5058 15.5681 46.6576 16.1989 46.9142 16.7894C47.1651 17.3497 47.5757 17.8234 48.0946 18.1513C48.7864 18.5372 49.5736 18.7179 50.3646 18.6724C51.1508 18.72 51.9342 18.5391 52.6202 18.1513C53.1342 17.8177 53.5432 17.3456 53.8006 16.7894C54.0714 16.2022 54.2333 15.5706 54.2784 14.9257C54.3261 14.2375 54.35 13.5638 54.35 12.909V0.660645H60.1567V13.7406C60.1567 17.2449 59.3602 19.8033 57.7672 21.4153C56.174 23.0276 53.71 23.8336 50.3741 23.8336C47.0481 23.8336 44.5789 23.0276 42.9669 21.4153C41.3547 19.8033 40.5535 17.2449 40.5631 13.7406V0.660645H46.3934Z" fill="#1C1C1C"/>
// <path d="M71.0335 23.1835H65.1792V0.660645H74.4934C77.02 0.660645 78.9569 1.31862 80.3044 2.63429C81.6522 3.95023 82.3243 5.80115 82.3213 8.18732C82.3213 10.5768 81.6489 12.4296 80.3044 13.7453C78.9602 15.0612 77.023 15.7173 74.4934 15.7143H71.0286V23.1835H71.0335ZM71.0335 10.9974H72.9736C75.1242 10.9974 76.1993 10.0608 76.1996 8.18732C76.1993 6.31409 75.1242 5.3791 72.9736 5.3821H71.0335V10.9974Z" fill="#1C1C1C"/>
// <path d="M98.5407 5.62129H91.5828V9.38218H98.1538V14.3425H91.5828V18.2232H98.5407V23.1835H85.7285V0.660645H98.5407V5.62129Z" fill="#1C1C1C"/>
// <path d="M121.804 23.1829H114.493L108.901 14.5188V23.1829H103.047V0.660021H112.156C113.277 0.637436 114.392 0.825467 115.444 1.21432C116.317 1.54031 117.107 2.05624 117.757 2.72455C118.362 3.35803 118.831 4.10961 119.133 4.93221C119.45 5.794 119.611 6.70477 119.611 7.62288C119.679 9.11243 119.241 10.5808 118.368 11.79C117.442 12.919 116.148 13.6853 114.713 13.955L121.804 23.1829ZM108.901 10.7291H110.005C110.947 10.7887 111.883 10.5369 112.667 10.0123C113.806 8.99352 113.903 7.2441 112.884 6.1053C112.816 6.02883 112.744 5.95645 112.667 5.88815C111.883 5.36351 110.947 5.11181 110.005 5.1714H108.901V10.7291Z" fill="#1C1C1C"/>
// <path d="M11.9627 34.5331H23.5801C23.5861 35.6196 23.5365 36.7059 23.432 37.7876C23.3441 38.7147 23.1433 39.6279 22.8347 40.5065C22.4437 41.6336 21.869 42.6881 21.1332 43.6274C20.4276 44.5221 19.5743 45.2898 18.6102 45.8974C17.6235 46.5143 16.5511 46.9812 15.4273 47.2833C14.2408 47.6068 13.0158 47.7676 11.7858 47.7611C10.152 47.781 8.52998 47.4874 7.00695 46.896C5.61155 46.3535 4.34513 45.5249 3.28878 44.4636C2.23135 43.388 1.40657 42.106 0.86588 40.6978C0.272944 39.1503 -0.0203955 37.5043 0.00110147 35.8471C-0.0182186 34.1995 0.26995 32.5624 0.85173 31.0206C1.3848 29.6152 2.20876 28.3384 3.26974 27.2739C4.35003 26.2167 5.63713 25.3933 7.04995 24.8559C8.62304 24.2589 10.2946 23.9636 11.9771 23.9862C14.1366 23.9399 16.2703 24.4659 18.1609 25.5106C20.0156 26.6148 21.4856 28.2633 22.3711 30.232L16.818 32.5306C16.4278 31.4625 15.7252 30.5368 14.8014 29.8737C13.9608 29.3303 12.9777 29.0492 11.9771 29.066C11.1553 29.0497 10.3398 29.2127 9.58768 29.5439C8.87801 29.8682 8.25079 30.3485 7.75255 30.9488C7.22056 31.5989 6.81538 32.3431 6.55769 33.1423C6.25619 34.0678 6.10925 35.0365 6.12285 36.0098C6.11496 36.9089 6.24041 37.8044 6.49565 38.6668C6.72368 39.4423 7.10546 40.1639 7.61866 40.7887C8.11936 41.3887 8.75256 41.8647 9.46823 42.1792C10.2818 42.5183 11.1581 42.681 12.0392 42.657C12.6024 42.6579 13.1638 42.592 13.7118 42.4611C14.2226 42.3381 14.7078 42.1264 15.1453 41.8353C15.5756 41.5433 15.9375 41.1618 16.2063 40.7169C16.504 40.2026 16.6956 39.6339 16.7701 39.0442H11.9627V34.5042V34.5331Z" fill="#1C1C1C"/>
// <path d="M39.2492 43.2209H30.8864L29.5435 47.1347H23.2974L31.8706 24.6167H38.2647L46.8333 47.1347H40.5921L39.2492 43.2209ZM37.6963 38.7715L35.0679 31.2734L32.4393 38.7715H37.6963Z" fill="#1C1C1C"/>
// <path d="M55.2583 24.6123V42.1748H62.2786V47.1352H49.4043V24.6123H55.2583Z" fill="#1C1C1C"/>
// <path d="M71.1479 24.6123V42.1748H78.1682V47.1352H65.2939V24.6123H71.1479Z" fill="#1C1C1C"/>
// <path d="M93.9958 29.5727H87.0376V33.3338H93.6086V38.2942H87.0376V42.1748H93.9958V47.1352H81.1836V24.6123H93.9958V29.5727Z" fill="#1C1C1C"/>
// <path d="M116.949 47.1347H109.647L104.065 38.4755V47.1347H98.2061V24.6167H107.319C108.439 24.5931 109.552 24.7795 110.602 25.1664C112.322 25.798 113.674 27.1597 114.292 28.8843C114.611 29.7453 114.773 30.6566 114.77 31.5747C114.837 33.0634 114.401 34.5312 113.532 35.7419C112.602 36.8692 111.307 37.6352 109.871 37.9068L116.949 47.1347ZM104.065 34.6809H105.169C106.11 34.7421 107.044 34.4899 107.826 33.9641C108.965 32.9532 109.069 31.2103 108.057 30.0713C107.985 29.9896 107.908 29.9124 107.826 29.84C107.044 29.3143 106.11 29.062 105.169 29.1232H104.065V34.6809Z" fill="#1C1C1C"/>
// <path d="M123.745 36.3206L115.535 24.6123H122.521L126.703 30.7675L130.856 24.6123H137.843L129.599 36.3206V47.1352H123.745V36.3206Z" fill="#1C1C1C"/>
// </svg>
//                   )}
//                 </Link>
//               </div>
//             </div>

//             <div className="col-8 col-md-5">
//               <div className="right-wrap d-flex align-items-center justify-content-end justify-content-lg-between careerFilter">
//                 <div className="header-search position-relative">
//       <form
//         className="d-none d-lg-block"
// onSubmit={handleSearchSubmit}
//         ref={searchRef}
//       >
//         <div className="form-group mb-0">
//           <input
//             type="text"
//             name="search"
//             placeholder={__("Search for a photographer")}
//             required
//             autoComplete="off"
//             onChange={(e) => {
//               setQuery(e.target.value);
//               setIsOpen(true);
//             }}
//             className="form-control"
//           />
//           <svg onClick={handleSearchSubmit}
//             width="20"
//             height="20"
//             viewBox="0 0 20 20"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
//               stroke="#1C1C1C"
//               strokeWidth="1.5"
//               strokeLinecap="square"
//             ></path>
//           </svg>
//         </div>
//       </form>

//       {isOpen && (loading || results.length > 0 || query.length > 1) && (
//         <div
//           className="position-absolute suggestions w-100 shadow-sm"
//           onMouseDown={(e) => e.preventDefault()}
//         >
//           {loading && (
//             <div className="text-center p-3 text-muted">Searching...</div>
//           )}

//           {!loading && results.length === 0 && query.length > 1 && (
//             <div className="text-center p-3 text-muted">No products found</div>
//           )}

//           {!loading && results.length > 0 && (
//             <ul className="list-unstyled mb-0">
//               {results.map((item) => (
//                 <li key={item.id}>
//                   <div
//                     className="row align-items-center"
//                     onClick={handleLinkClick}
//                     onMouseDown={() => {
//                       navigate(`/product/${item.slug}`);
//                       setIsOpen(false);
//                     }}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <div className="col-4 col-md-4">
//                       <figure className="p-0 m-0">
//                         <img src={item.image} alt={item.name} className="w-100" />
//                       </figure>
//                     </div>

//                     <div className="col-8 col-md-8">
//                       <article className="d-flex justify-content-between align-items-start flex-wrap flex-md-nowrap">
//                         <span className="text-dark">{item.name}</span>
//                       </article>
//                     </div>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>
//       )}
//     </div>



//                 <div className="header-icons">
//                   <ul className="d-flex align-items-center justify-content-end justify-content-lg-between">
//                     <li className="menuDrop cartMenu profileMenu">
//                       {isAuthenticated ? (
//                         <>
//                           <button
//                             className="icons border-0 bg-transparent p-0"
//                             aria-expanded="false"
//                           >
//                             <svg
//                               width="24"
//                               height="24"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
//                                 stroke="#1C1C1C"
//                                 strokeWidth="2"
//                                 strokeLinecap="square"
//                               />
//                             </svg>
//                           </button>
//                           <div className="sub-menu drop-menu text-start h-auto">
//                             {/* USER INFO */}
//                             {/* <p className="text-center">{user?.firstname} {user?.lastname}</p>
//           <hr className="dropdown-divider" /> */}
//                             <ul>

//                               {/* ACTIONS */}
//                               <li>
//                                 <Link to="/account">
//                                   {__("Profile")}
//                                 </Link>
//                               </li>

//                               <li>
//                                 <Link
//                                   onClick={handleLogout}
//                                 >
//                                   {__("Logout")}
//                                 </Link>
//                               </li>
//                             </ul>
//                           </div>

//                         </>
//                       ) : (
//                         <Link className="icons" to="/signup">
//                           <svg
//                             width="24"
//                             height="24"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path
//                               d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
//                               stroke="#1C1C1C"
//                               strokeWidth="2"
//                               strokeLinecap="square"
//                             />
//                           </svg>
//                         </Link>
//                       )}
//                     </li>



//                     <li>
//                       <Link to="/wishlist" className="icons cart_icon">
//                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="square"></path></svg>
// {wishlist.count > 0 && (
//   <span className="cart-count-badge">
//     {wishlist.count}
//   </span>
// )}

//                       </Link>
//                     </li>

//                     <li className="menuDrop cartMenu">
//                       <Link to="checkout" className="icons cart_icon" onClick={() => setIsOpen(!isOpen)}>
//                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                           <path d="M16.0004 9V6C16.0004 3.79086 14.2095 2 12.0004 2C9.79123 2 8.00037 3.79086 8.00037 6V9M3.59237 10.352L2.99237 16.752C2.82178 18.5717 2.73648 19.4815 3.03842 20.1843C3.30367 20.8016 3.76849 21.3121 4.35839 21.6338C5.0299 22 5.94374 22 7.77142 22H16.2293C18.057 22 18.9708 22 19.6423 21.6338C20.2322 21.3121 20.6971 20.8016 20.9623 20.1843C21.2643 19.4815 21.179 18.5717 21.0084 16.752L20.4084 10.352C20.2643 8.81535 20.1923 8.04704 19.8467 7.46616C19.5424 6.95458 19.0927 6.54511 18.555 6.28984C17.9444 6 17.1727 6 15.6293 6L8.37142 6C6.82806 6 6.05638 6 5.44579 6.28984C4.90803 6.54511 4.45838 6.95458 4.15403 7.46616C3.80846 8.04704 3.73643 8.81534 3.59237 10.352Z" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="square"></path>
//                         </svg>
//                         {cart?.products?.length > 0 && (
//                           <span className="cart-count-badge">
//                             {cart.products.length}
//                           </span>
//                         )}
//                       </Link>

//                       <div className="sub-menu drop-menu text-start">
//                         <div className="menuWrap">
//                           {(!cart?.products || cart.products.length === 0) && (
//                             <div className="emptyBag text-center">
//                               <span className="d-block mb-3"><i className="icons icon-bag"></i></span>
//                               <p><strong>{__("You currently dont have any items in your bag")}</strong></p>
//                               <Link to="/shop" className="btn w-100" onClick={() => setIsOpen(false)}>
//                                 {__("Shop Now")}
//                               </Link>
//                             </div>
//                           )}

//                           {cart?.products?.length > 0 && (
//                             <>
//                               <h4 className="cart-title">{__("My Bag")}</h4>
//                               <ul>
//                                 {cart.products.map((item, index) => {
//                                   const price = item.discount_price || item.price;

//                                   return (
//                                     <li key={index}>
//                                       <Link
//                                         to={`/product/${item.id}-${item.link_rewrite}`}
//                                         className="d-flex flex-wrap align-items-center gap-3"
//                                         onClick={() => setIsOpen(false)}
//                                       >
//                                         <figure>
//                                           <img
//                                             src={item.images?.[0]?.bySize?.cart_default?.url || item.default_image?.bySize?.cart_default?.url}
//                                             alt={item.name}
//                                           />
//                                           {item.tag && <figcaption className="mt-2"></figcaption>}
//                                         </figure>

//                                         <div className="description">
//                                           <h6>{item.name} <b>({item.quantity_wanted})</b></h6>
//                                           {item.attributes && Object.keys(item.attributes).length > 0 && (
//                                             <p className="mb-2">(
//                                               {Object.values(item.attributes).join(", ")}
//                                               )</p>
//                                           )}
//                                           <ol>
//                                             <li>
//                                               <strong>{price}</strong>
//                                               {item.discount_price && (
//                                                 <del style={{ marginLeft: "10px" }}>
//                                                   <strong>{item.price}</strong>
//                                                 </del>
//                                               )}
//                                             </li>
//                                           </ol>
//                                         </div>
//                                       </Link>
//                                       <button
//                                         className="remove-btn"
//                                         onClick={(e) => {
//                                           e.preventDefault();
//                                           handleRemove(item);
//                                         }}
//                                       ></button>

//                                     </li>

//                                   );
//                                 })}

//                               </ul>
//                               <div className="emptyBag p-3 text-center">
//                                 <Link className="btn w-100" to="/checkout" onClick={() => setIsOpen(false)}>
//                                   {__("Checkout")}
//                                 </Link>
//                               </div>
//                             </>

//                           )}

//                         </div>
//                       </div>

//                     </li>
//                     <li className="d-block d-lg-none">
//                       <Link href="javascript:;" className="burgermenu text-end" data-bs-toggle="offcanvas" data-bs-target="#mainMenu">
//                         <svg width="30" height="30" viewBox="0 0 72 37" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L71 0.999994" stroke="#1C1C1C" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1 18.5L71 18.5" stroke="#1C1C1C" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1 36L71 36" stroke="#1C1C1C" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
//                       </Link>
//                     </li>

//                   </ul>
//                 </div>
// <div className="form-group ct-slct mb-0">
//   {/* Label removed as requested */}
//   <div className="child_option position-relative">
//     <button
//       className="form-control open-menu2 text-start d-flex align-items-center justify-content-between"
//       type="button"
//       onClick={(e) => e.preventDefault()}
//     >
//       {site_settings.languages?.find(
//         (l) => Number(l.id_lang) === Number(site_settings.current_lang_id)
//       )?.name || "Select Language"} 
      
//                           <svg className="ms-2"
//                             width="14"
//                             height="8"
//                             viewBox="0 0 14 8"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path
//                               opacity="0.6"
//                               d="M1 1L7 7L13 1"
//                               stroke="#222222"
//                               strokeLinecap="round"
//                             />
//                           </svg>    </button>

//     <div className="dropdown-menu2 dropdown-menu-right">
//       <ul className="careerFilterInr">
//         {site_settings.languages && site_settings.languages
//           .filter((lang) => Number(lang.id_lang) !== Number(site_settings.current_lang_id))
//           .map((lang) => (
//             <li key={lang.id_lang}>
//               <a
//                 href="#"
//                 className="dropdown_select"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   const payload = { lang_id: lang.id_lang };
                  
//                   dispatch({ type: 'CcommonContent_sync', payload: payload });
//                   dispatch({ type: 'Chome_sync', payload: payload });
//                   dispatch({ type: 'CContactPage_sync', payload: payload });
//                   dispatch({ type: 'CDataProtectionPage_sync', payload: payload });
//                   dispatch({ type: 'CTermsConditionsPage_sync', payload: payload });
//                   dispatch({ type: 'CGalleryCollectionPage_sync', payload: payload });
//                   dispatch({ type: 'CFramesPage_sync', payload: payload });
//                   dispatch({ type: 'CQualityPrintsPage_sync', payload: payload });
//                   dispatch({ type: 'COurLabsPage_sync', payload: payload });
//                   dispatch({ type: 'Cproducts_sync', payload: payload });
//                 }}
//               >
//                 {lang.name}
//               </a>
//             </li>
//           ))}
//       </ul>
//     </div>
//   </div>
// </div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </header>
//     </>
//   );
// }

// export default Header;
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { BASE_PATH, base_url } from "../components/config";
import { useNavigate } from "react-router-dom";
import { useTranslate } from '../hooks/useTranslate';
import { FullLinkLang, LinkLang } from "./LinkLang";
import { trackRemoveFromCart } from "./track";

// ─── Mega Menu Component for Desktop ─────────────────────────────────────────
function MegaMenuPanel({ sections }) {
  const [activeId, setActiveId] = useState(sections?.[0]?.id_menu ?? null);
  const { languages } = useSelector(
        (s) => s.languages
    );
  if (!sections || sections.length === 0) return null;

  return (
    <div className="navbar-theme-content">
      <div className="navbar-theme-sections">
        <div className="sections-titles">
          {sections.map((section) => (
            <a
              key={section.id_menu}
              className={`sections-title${activeId === section.id_menu ? " sections-title-active" : ""}`}
              data-category="direct-link"
              data-section-id={section.id_menu}
              href="javascript:;"
              onMouseEnter={() => setActiveId(section.id_menu)}
              onClick={() => setActiveId(section.id_menu)}
            >
              <div className="section-title">{section.title}</div>
              <div className="section-arrow">
                <svg className="logo-caret logo-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 4.5L16.5 12L9 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </a>
          ))}
        </div>

        <div className="sections-links">
          {sections.map((section) => {
            // section.button_link
            
                let  btn_link = FullLinkLang(section.link)
            const isFullUrl = /^https?:\/\//i.test(section.button_link);

            if (isFullUrl) {
                  btn_link = FullLinkLang(section.link)
              } else {
                  btn_link = LinkLang(section.link)
              }
            
            return(
            <div
              key={section.id_menu}
              className={`section-links${activeId === section.id_menu ? " section-link-active" : ""}`}
              data-section-id={section.id_menu}
            >
              <div className="sections-links-main">
                <div className="sections-links-header">
                  <h3 className="section-links-title">{section.title}</h3>
                  {section.button && (
                    <Link className="section-links-global" to={btn_link || "javascript:;"}>
                      {section.button}
                    </Link>
                  )}
                </div>

                {section.children?.length > 0 && (
                  <div className="sections-links-container">
                    {(() => {
                      const columnsMap = new Map();
                      section.children.forEach((child) => {
                        const groupId = child.column_group || 1;
                        if (!columnsMap.has(groupId)) {
                          columnsMap.set(groupId, {
                            group: groupId,
                            heading: child.column_heading || '',
                            order: child.column_order || 0,
                            items: []
                          });
                        }
                        columnsMap.get(groupId).items.push(child);
                      });
                      const columns = Array.from(columnsMap.values()).sort((a, b) => a.order - b.order);
                      return columns.map((column) => (
                        <div key={column.group} className="sections-links-categories">
                          {column.heading && <h4 className="section-links-subtitle">{column.heading}</h4>}
                          <ul>
                            {column.items.map((child) => {
                              
                              const isFullUrl_child = /^https?:\/\//i.test(child.link);
                              let link = LinkLang(child.link)
                              if (isFullUrl_child) {
                                  link = FullLinkLang(child.link)
                              } else {
                                  link = LinkLang(child.link)
                              }
                                
                                
                              return(
                              <li key={child.id_menu}>
                                <Link className="section-links-link link" to={link}>{child.title}</Link>
                              </li>
                            )})}
                          </ul>
                        </div>
                      ));
                    })()}
                  </div>
                )}
              </div>
              {section.image && (
                <div className="sections-links-image-container">
                  <img className="sections-links-image" alt={section.title || ""} loading="lazy" src={section.image} />
                  {section.text && <div className="sections-links-image-legend" dangerouslySetInnerHTML={{ __html: section.text }} />}
                </div>
              )}
            </div>
          )})}
        </div>
      </div>
    </div>
  );
}

// ─── Desktop Nav Item ─────────────────────────────────────────────────────────
function NavItem({ item }) {
  const megaSections = (item.children || []).filter((c) => c.type === "mega");
  const hasMega = megaSections.length > 0;
 
            let btn_link = FullLinkLang(item.link)
            

            const isFullUrl = /^https?:\/\//i.test(item.link);

      if (isFullUrl) {
          btn_link = FullLinkLang(item.link)
      } else {
          btn_link = LinkLang(item.link)
      }
  if (hasMega) {
    
    return (
      <li className="has-mega-menu">
        <Link to={btn_link} className="link drop-menu">{item.title}</Link>
        <MegaMenuPanel sections={megaSections} />
      </li>
    );
  }
  return (
    <li>
      <Link to={btn_link} className="link">{item.title}</Link>
    </li>
  );
}

// ─── Mobile Mega Menu Components ─────────────────────────────────────────────
function MobileMenuItem({ item, onNavigate, level = 1 }) {
  const megaSections = (item.children || []).filter((c) => c.type === "mega");
  const hasMega = megaSections.length > 0;
  // Create a unique ID for this menu item
  const uniqueId = (item.id_menu || item.id_custom_menu || Math.random()).toString().replace(/[^a-z0-9]/gi, '');
  const menuId = `menu-${uniqueId}`;
  const isFullUrl_child = /^https?:\/\//i.test(item.button_link);
  let btn_link = LinkLang(item.button_link)
  if (isFullUrl_child) {
      btn_link = FullLinkLang(item.button_link)
  } else {
      btn_link = LinkLang(item.button_link)
  }
  if (hasMega) {
    return (
      <>
        {/* Level 1 Entry */}
        <a className="navbar-drawer-entry" data-navbar-mobile-entry={menuId} href="javascript:;">
          <div className="drawer-navbar-sub-link">
            <div className="drawer-navbar-sub-name">{item.title}</div>
            <svg className="logo-caret logo-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path className="logo-caret-path logo-caret-right-path" d="M9 4.5L16.5 12L9 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </a>

        {/* Level 2 - Categories (Movie, Music, etc.) - This should be outside the entries list */}
        <div className="nav-mobile__level-2 translateX-right" data-navbar-mobile-level2={menuId}>
          <div className="nav-mobile__level-2-item" data-navbar-mobile-entry={menuId}>
            <a className="drawer-navbar-entry-back drawer-navbar-back" href="#">
              <div className="title">
                <div className="drawer-navbar-back-icon">
                  <svg className="logo-caret logo-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path className="logo-caret-path logo-caret-right-path" d="M9 4.5L16.5 12L9 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="drawer-navbar-back-title">{item.title}</div>
              </div>
              <div className="cross">
                <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
              </div>
            </a>
            <div className="drawer-navbar-links-collection">
              {megaSections.map((section) => (
                <a 
                  key={section.id_menu} 
                  className="navbar-drawer-category-level-2" 
                  data-navbar-category={`category-${section.id_menu}`} 
                  href="javascript:;"
                >
                  <div className="drawer-navbar-sub-link">
                    <div className="section-title">{section.title}</div>
                    <div className="section-arrow">
                      <svg className="logo-caret logo-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path className="logo-caret-path logo-caret-right-path" d="M9 4.5L16.5 12L9 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </a>
              ))}
              {item.button && (
                <Link className="drawer-navbar-global" to={btn_link || "javascript:;"} onClick={onNavigate}>
                  {item.button}
                </Link>
              )}
            </div>
          </div>
        </div>

        {/* Level 3 - Actual links for each section - These should be siblings of Level 2 */}
        {megaSections.map((section) => (
          <div key={section.id_menu} className="nav-mobile__level-3 translateX-right" data-navbar-category-level3={`category-${section.id_menu}`}>
            <div className="nav-mobile__level-3-item" data-navbar-category={`category-${section.id_menu}`}>
              <a className="nav-mobile__level-3-back drawer-navbar-back" href="#">
                <div className="title">
                  <div className="drawer-navbar-back-icon">
                    <svg className="logo-caret logo-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path className="logo-caret-path logo-caret-right-path" d="M9 4.5L16.5 12L9 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="drawer-navbar-back-title">{section.title}</div>
                </div>
                <div className="cross">
                  <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
                </div>
              </a>
              <div className="drawer-navbar-links-collection">
                {(() => {
                  const columnsMap = new Map();
                  section.children?.forEach((child) => {
                    const groupId = child.column_group || 1;
                    if (!columnsMap.has(groupId)) {
                      columnsMap.set(groupId, {
                        heading: child.column_heading || '',
                        items: []
                      });
                    }
                    columnsMap.get(groupId).items.push(child);
                  });
                  const columns = Array.from(columnsMap.values());
                  
                  return columns.map((column, idx) => (
                    <div key={idx}>
                      {column.heading && <div className="drawer-navbar-title">{column.heading}</div>}
                      {column.items.map((child) => { 
                        const isFullUrl = /^https?:\/\//i.test(child.link);
                              let link = LinkLang(child.link)
                              if (isFullUrl) {
                                  link = FullLinkLang(child.link)
                              } else {
                                  link = LinkLang(child.link)
                              }
                        return(
                        <Link 
                          key={child.id_menu} 
                          className="drawer-navbar-link" 
                          data-category={section.title}
                          to={link} 
                          onClick={onNavigate}
                        >
                          {child.title}
                        </Link>
                      )})}
                      {idx < columns.length - 1 && <div className="navbar-drawer-divider"></div>}
                    </div>
                  ));
                })()}
                {section.button && (
                  <>
                    <div className="navbar-drawer-divider"></div>
                    <Link className="drawer-navbar-global" to={"javascript:;"} onClick={onNavigate}>
                      {section.button}
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </>
    );
  }

  // Simple link
  const getLinkUrl = () => {
    if (item.link) {
      if (!item.link.startsWith('http') && !item.link.startsWith('#') && !item.link.includes('index.php')) {
        return `/${item.link}`;
      }
      if (item.link.match(/^\d+-[a-z0-9-]+$/)) {
        return `${item.link}`;
      }
    }
    return item.link || '#';
  };

  return (
    <Link className="navbar-drawer-entry" data-link="true" to={getLinkUrl()} onClick={onNavigate}>
      <div className="drawer-navbar-sub-link">{item.title}</div>
    </Link>
  );
}

// ─── Main Header ──────────────────────────────────────────────────────────────
function Header({ data = [], agc_menu = [], site_settings = [] }) {
  const __ = useTranslate();
  const { isAuthenticated, user } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const cart = useSelector(state => state.home.common_data?.cart || { products: [] });
  const wishlist = useSelector(state => state.home.common_data?.wishlist || { products: [], count: 0 });
  const { languages } = useSelector(
        (s) => s.languages
    );


  const closeBtnRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setIsOpen(false); }, [location]);

  const dispatch = useDispatch();
  useEffect(() => { dispatch({ type: 'CCheckAuth_sync' }); }, [dispatch]);

  const handleRemove = (item) => {
    dispatch({ type: "CCart_remove", data: { product_id: item.id, id_product_attribute: item.id_product_attribute ?? null, id_customization: item.id_customization ?? 0 } });
    trackRemoveFromCart(item, 1);
  };

  const handleLogout = () => { dispatch({ type: 'CLogout_sync' }); };
  const handleLinkClick = () => { if (closeBtnRef.current) closeBtnRef.current.click(); };

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (query.length < 2) { setResults([]); return; }
    const timeout = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetch(`${base_url}ps_checkoutapi/api/?action=search&q=${encodeURIComponent(query)}`, { credentials: "include" });
        const data = await res.json();
        setResults(data.products || []);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    }, 300);
    return () => clearTimeout(timeout);
  }, [query]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!query) return;
    setIsOpen(false);
    if (closeBtnRef.current) closeBtnRef.current.click();
    navigate({ pathname: LinkLang("/shop"), search: `?search=${encodeURIComponent(query)}` });
    
  };

  const searchRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target)) setIsOpen(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Mobile menu navigation
//   useEffect(() => {
//     const $ = window.jQuery;
//     if (!$) return;

// const $document = $(document);

//     // Desktop mega menu hover
// // Desktop mega menu hover - FIXED: closes others when hovering new one
// let hoverTimeout;

// $('.has-mega-menu').on('mouseenter', function() {
//     if (hoverTimeout) clearTimeout(hoverTimeout);
//     // Hide all other mega menus first
//     $('.navbar-theme-content').not($(this).find('.navbar-theme-content')).removeClass('active').hide();
//     // Show this one
//     $(this).find('.navbar-theme-content').addClass('active').stop(true, true).fadeIn(200);
// }).on('mouseleave', function() {
//     const $menu = $(this).find('.navbar-theme-content');
//     hoverTimeout = setTimeout(function() {
//         if (!$menu.is(':hover')) {
//             $menu.removeClass('active').fadeOut(200);
//         }
//     }, 150);
// });

// $('.navbar-theme-content').on('mouseenter', function() {
//     if (hoverTimeout) clearTimeout(hoverTimeout);
//     $(this).addClass('active').stop(true, true).show();
// }).on('mouseleave', function() {
//     $(this).removeClass('active').stop(true, true).fadeOut(200);
// });

//     $('.sections-title').hover(function() {
//       let sectionId = $(this).data('section-id');
//       $(this).addClass('sections-title-active').siblings('.sections-title').removeClass('sections-title-active');
//       let parentWrap = $(this).closest('.navbar-theme-sections');
//       parentWrap.find('.section-links').removeClass('section-link-active').hide();
//       parentWrap.find(`.section-links[data-section-id="${sectionId}"]`).addClass('section-link-active').show();
//     });

//     $document.on('click', '.careerFilterInr li a', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
//       const $childOption = $(this).closest('.child_option');
//       const $button = $childOption.find('button').first();
//       $button.text($(this).text());
//       $childOption.find('.dropdown-menu2').slideUp('fast');
//       $childOption.find('.open-menu2').removeClass('active');
//     });

//     $document.on('click', '.careerFilter .child_option > .open-menu2', function(e) {
//       e.stopPropagation();
//       const $toggle = $(this);
//       const $menu = $toggle.siblings('.dropdown-menu2');
//       if ($toggle.hasClass('active')) {
//         $menu.slideUp('fast');
//         $toggle.removeClass('active');
//       } else {
//         $('.dropdown-menu2').slideUp('fast');
//         $('.open-menu2').removeClass('active');
//         $menu.slideDown('fast');
//         $toggle.addClass('active');
//       }
//     });

//     $document.on('click', function() {
//       $('.dropdown-menu2').slideUp('fast');
//       $('.open-menu2').removeClass('active');
//     });

//     return () => {
//       $document.off('click', '.careerFilterInr li a');
//       $document.off('click', '.careerFilter .child_option > .open-menu2');
//       $document.off('click');
//     };
//   }, []);
useEffect(() => {
    const $ = window.jQuery;

    if (!$) return;

    const $document = $(document);

    let hoverTimeout = null;

    // =========================================================
    // DESKTOP MEGA MENU - OPEN
    // =========================================================

    $document.on(
        "mouseenter.headerMega",
        ".has-mega-menu",
        function () {
            if (hoverTimeout) {
                clearTimeout(hoverTimeout);
                hoverTimeout = null;
            }

            const $currentItem = $(this);
            const $currentMenu = $currentItem.find(
                ".navbar-theme-content"
            );

            // Close all other mega menus
            $(".navbar-theme-content")
                .not($currentMenu)
                .removeClass("active")
                .stop(true, true)
                .hide();

            // Open current mega menu
            $currentMenu
                .addClass("active")
                .stop(true, true)
                .fadeIn(200);
        }
    );


    // =========================================================
    // DESKTOP MEGA MENU - CLOSE
    // =========================================================

    $document.on(
        "mouseleave.headerMega",
        ".has-mega-menu",
        function () {
            const $menu = $(this).find(
                ".navbar-theme-content"
            );

            hoverTimeout = setTimeout(() => {
                if (!$menu.is(":hover")) {
                    $menu
                        .removeClass("active")
                        .stop(true, true)
                        .fadeOut(200);
                }
            }, 150);
        }
    );


    // =========================================================
    // MEGA MENU CONTENT - MOUSE ENTER
    // =========================================================

    $document.on(
        "mouseenter.headerMega",
        ".navbar-theme-content",
        function () {
            if (hoverTimeout) {
                clearTimeout(hoverTimeout);
                hoverTimeout = null;
            }

            $(this)
                .addClass("active")
                .stop(true, true)
                .show();
        }
    );


    // =========================================================
    // MEGA MENU CONTENT - MOUSE LEAVE
    // =========================================================

    $document.on(
        "mouseleave.headerMega",
        ".navbar-theme-content",
        function () {
            $(this)
                .removeClass("active")
                .stop(true, true)
                .fadeOut(200);
        }
    );


    // =========================================================
    // MEGA MENU SECTION HOVER
    // =========================================================

    $document.on(
        "mouseenter.headerMega",
        ".sections-title",
        function () {
            const sectionId = $(this).data("section-id");

            // Active section title
            $(this)
                .addClass("sections-title-active")
                .siblings(".sections-title")
                .removeClass("sections-title-active");

            const $parentWrap = $(this).closest(
                ".navbar-theme-sections"
            );

            // Hide all sections
            $parentWrap
                .find(".section-links")
                .removeClass("section-link-active")
                .hide();

            // Show selected section
            $parentWrap
                .find(
                    `.section-links[data-section-id="${sectionId}"]`
                )
                .addClass("section-link-active")
                .show();
        }
    );


    // =========================================================
    // LANGUAGE DROPDOWN ITEM CLICK
    // =========================================================

    $document.on(
        "click.headerDropdown",
        ".careerFilterInr li a",
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $childOption = $(this).closest(
                ".child_option"
            );

            const $button = $childOption
                .find("button")
                .first();

            // Update selected language text
            $button.html($(this).text()+' '+ ' <svg className="ms-2" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.6" d="M1 1L7 7L13 1" stroke="#222222" strokeLinecap="round" /></svg>' );

            // Close dropdown
            $childOption
                .find(".dropdown-menu2")
                .slideUp("fast");

            $childOption
                .find(".open-menu2")
                .removeClass("active");
        }
    );


    // =========================================================
    // LANGUAGE DROPDOWN TOGGLE
    // =========================================================

    $document.on(
        "click.headerDropdown",
        ".careerFilter .child_option > .open-menu2",
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $toggle = $(this);

            const $menu = $toggle.siblings(
                ".dropdown-menu2"
            );

            // Already open
            if ($toggle.hasClass("active")) {

                $menu.slideUp("fast");

                $toggle.removeClass("active");

            } else {

                // Close other dropdowns
                $(".dropdown-menu2")
                    .slideUp("fast");

                $(".open-menu2")
                    .removeClass("active");

                // Open current dropdown
                $menu.slideDown("fast");

                $toggle.addClass("active");
            }
        }
    );


    // =========================================================
    // CLOSE LANGUAGE DROPDOWN ON OUTSIDE CLICK
    // =========================================================

    $document.on(
        "click.headerDropdownOutside",
        function () {
            $(".dropdown-menu2")
                .slideUp("fast");

            $(".open-menu2")
                .removeClass("active");
        }
    );


    // =========================================================
    // CLEANUP
    // =========================================================

    return () => {
        if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            hoverTimeout = null;
        }

        // Remove ONLY our handlers
        $document.off(".headerMega");
        $document.off(".headerDropdown");
        $document.off(".headerDropdownOutside");
    };

}, []);
   const desktopNav = agc_menu?.length > 0 ? agc_menu : data;

  // Collect all level 2 and level 3 menus to render as siblings
  const [level2Menus, setLevel2Menus] = useState([]);
  const [level3Menus, setLevel3Menus] = useState([]);

  useEffect(() => {
    const level2 = [];
    const level3 = [];

    desktopNav.forEach((item) => {
      const megaSections = (item.children || []).filter((c) => c.type === "mega");
      if (megaSections.length > 0) {
        const uniqueId = (item.id_menu || item.id_custom_menu || Math.random()).toString().replace(/[^a-z0-9]/gi, '');
        const menuId = `menu-${uniqueId}`;

        // Collect Level 2
        level2.push({ item, menuId, megaSections });

        // Collect Level 3 for each section
        megaSections.forEach((section) => {
          level3.push({ section, categoryId: `category-${section.id_menu}` });
        });
      }
    });

    setLevel2Menus(level2);
    setLevel3Menus(level3);
  }, [desktopNav]);

useEffect(() => {
  const $ = window.jQuery;
  if (!$) return;

  // Initialize - add classes on mount
  $('.nav-mobile__level-2, .nav-mobile__level-3').addClass('translateX-right');
  $('.nav-mobile__level-2-item, .nav-mobile__level-3-item').hide();

  // Navigate to Level 2
  $(document).on('click', '[data-navbar-mobile-entry]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    let target = $(this).data('navbar-mobile-entry');
    
    // Hide all level-2 and level-3 items first
    $('.nav-mobile__level-2-item').hide();
    $('.nav-mobile__level-3').addClass('translateX-right');
    
    // Show the specific level-2 item
    $(`.nav-mobile__level-2-item[data-navbar-mobile-entry="${target}"]`).show();
    // Show the specific level-2 container
    $(`.nav-mobile__level-2[data-navbar-mobile-level2="${target}"]`).removeClass('translateX-right');
  });

  // Navigate to Level 3
  $(document).on('click', '[data-navbar-category]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    let category = $(this).data('navbar-category');
    
    // Hide all level-3 items
    $('.nav-mobile__level-3-item').hide();
    // Show the specific level-3 item
    $(`.nav-mobile__level-3-item[data-navbar-category="${category}"]`).show();
    // Show the specific level-3 container
    $(`.nav-mobile__level-3[data-navbar-category-level3="${category}"]`).removeClass('translateX-right');
  });

  // Back from Level 2 to Level 1
  $(document).on('click', '.drawer-navbar-entry-back', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).closest('.nav-mobile__level-2').addClass('translateX-right');
  });

  // Back from Level 3 to Level 2
  $(document).on('click', '.nav-mobile__level-3-back', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).closest('.nav-mobile__level-3').addClass('translateX-right');
  });

  // Cleanup
  return () => {
    $(document).off('click', '[data-navbar-mobile-entry]');
    $(document).off('click', '[data-navbar-category]');
    $(document).off('click', '.drawer-navbar-entry-back');
    $(document).off('click', '.nav-mobile__level-3-back');
  };
}, [desktopNav]);

  return (
    <>
      {/* Offcanvas Mobile Menu */}
<div className="offcanvas offcanvas-end" id="mainMenu">
        <div className="offcanvas-body">
          <div className="navbar-drawer-container">
            
            {/* Level 1 */}
            <div className="nav-mobile__level-1">
              <div className="drawer-heading navbar-drawer-heading">
                <div className="headerlogo">
                  <Link className="logo d-block" to={LinkLang("/")} onClick={handleLinkClick}>
                    {site_settings.head_logo && (
                      <img src={site_settings.head_logo} alt="Logo" width={109} height={38} className="w-100 header-logo-image" />
                    )}
                  </Link>
                  <button type="button" className="btn-close" data-bs-dismiss="offcanvas" ref={closeBtnRef} aria-label={__("Close menu")}></button>
                </div>
              </div>
              <div className="drawer-body navbar-drawer-body">
                <div className="navbar-drawer-entries">
                  {desktopNav.map((item) => {
                    const hasMega = (item.children || []).some((c) => c.type === "mega");
                    if (hasMega) {
                      const uniqueId = (item.id_menu || item.id_custom_menu || Math.random()).toString().replace(/[^a-z0-9]/gi, '');
                      const menuId = `menu-${uniqueId}`;
                      return (
                        <a key={item.id_menu ?? item.id_custom_menu} className="navbar-drawer-entry" data-navbar-mobile-entry={menuId} href="javascript:;">
                          <div className="drawer-navbar-sub-link">
                            <div className="drawer-navbar-sub-name">{item.title}</div>
                            <svg className="logo-caret logo-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path className="logo-caret-path logo-caret-right-path" d="M9 4.5L16.5 12L9 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                        </a>
                      );
                    }
                    // Simple link
                    const getLinkUrl = () => {
                      if (item.link) {
                        if (!item.link.startsWith('http') && !item.link.startsWith('#') && !item.link.includes('index.php')) {
                          return `/${item.link}`;
                        }
                        if (item.link.match(/^\d+-[a-z0-9-]+$/)) {
                          return `${item.link}`;
                        }
                      }
                      return item.link || '#';
                    };
                    return (
                      <Link key={item.id_menu ?? item.id_custom_menu} className="navbar-drawer-entry" data-link="true" to={getLinkUrl()} onClick={handleLinkClick}>
                        <div className="drawer-navbar-sub-link">{item.title}</div>
                      </Link>
                    );
                  })}
                </div>
              </div>
              <div className="right-wrap">
                <form onSubmit={handleSearchSubmit}>
                  <div className="form-group mb-0">
                    <input type="text" name="search" placeholder={__("Search for a photographer")} required className="form-control" value={query} onChange={(e) => { setQuery(e.target.value); setIsOpen(true); }} />
                    <svg onClick={handleSearchSubmit} width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z" stroke="#1C1C1C" strokeWidth="1.5" strokeLinecap="square"/>
                    </svg>
                  </div>
                </form>
              </div>
            </div>

            {/* Level 2 - All level 2 containers as siblings */}
            {level2Menus.map(({ item, menuId, megaSections }) => (
              <div key={menuId} className="nav-mobile__level-2 translateX-right" data-navbar-mobile-level2={menuId}>
                <div className="nav-mobile__level-2-item" data-navbar-mobile-entry={menuId}>
                  <a className="drawer-navbar-entry-back drawer-navbar-back" href="#">
                    <div className="title">
                      <div className="drawer-navbar-back-icon">
                        <svg className="logo-caret logo-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path className="logo-caret-path logo-caret-right-path" d="M9 4.5L16.5 12L9 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <div className="drawer-navbar-back-title">{item.title}</div>
                    </div>
                    <div className="cross">
                      <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
                    </div>
                  </a>
                  <div className="drawer-navbar-links-collection">
                    {megaSections.map((section) => (
                      <a key={section.id_menu} className="navbar-drawer-category-level-2" data-navbar-category={`category-${section.id_menu}`} href="javascript:;">
                        <div className="drawer-navbar-sub-link">
                          <div className="section-title">{section.title}</div>
                          <div className="section-arrow">
                            <svg className="logo-caret logo-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path className="logo-caret-path logo-caret-right-path" d="M9 4.5L16.5 12L9 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                        </div>
                      </a>
                    ))}
                    {item.button && (
                      <Link className="drawer-navbar-global" to={item.button_link || "javascript:;"} onClick={handleLinkClick}>
                        {item.button}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ))}

            {/* Level 3 - All level 3 containers as siblings */}
            {level3Menus.map(({ section, categoryId }) => {
                
                let  btn_link = FullLinkLang(section.link)
            const isFullUrl = /^https?:\/\//i.test(section.button_link);

            if (isFullUrl) {
                  btn_link = FullLinkLang(section.link)
              } else {
                  btn_link = LinkLang(section.link)
              }
              return(
              <div key={categoryId} className="nav-mobile__level-3 translateX-right" data-navbar-category-level3={categoryId}>
                <div className="nav-mobile__level-3-item" data-navbar-category={categoryId}>
                  <a className="nav-mobile__level-3-back drawer-navbar-back" href="#">
                    <div className="title">
                      <div className="drawer-navbar-back-icon">
                        <svg className="logo-caret logo-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path className="logo-caret-path logo-caret-right-path" d="M9 4.5L16.5 12L9 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <div className="drawer-navbar-back-title">{section.title}</div>
                    </div>
                    <div className="cross">
                      <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
                    </div>
                  </a>
                  <div className="drawer-navbar-links-collection">
                    {(() => {
                      const columnsMap = new Map();
                      section.children?.forEach((child) => {
                        const groupId = child.column_group || 1;
                        if (!columnsMap.has(groupId)) {
                          columnsMap.set(groupId, {
                            heading: child.column_heading || '',
                            items: []
                          });
                        }
                        columnsMap.get(groupId).items.push(child);
                      });
                      const columns = Array.from(columnsMap.values());
                      
                      return columns.map((column, idx) => (
                        <div key={idx}>
                          {column.heading && <div className="drawer-navbar-title">{column.heading}</div>}
                          {column.items.map((child) => {
                             const isFullUrl_child = /^https?:\/\//i.test(child.link);
                              let link = LinkLang(child.link)
                              if (isFullUrl_child) {
                                  link = FullLinkLang(child.link)
                              } else {
                                  link = LinkLang(child.link)
                              }
                            return(
                            <Link 
                              key={child.id_menu} 
                              className="drawer-navbar-link" 
                              data-category={section.title}
                              to={link} 
                              onClick={handleLinkClick}
                            >
                              {child.title}
                            </Link>
                          )})}
                          {idx < columns.length - 1 && <div className="navbar-drawer-divider"></div>}
                        </div>
                      ));
                    })()}
                    {section.button && (
                      <>
                        <div className="navbar-drawer-divider"></div>
                        <Link className="drawer-navbar-global" to={btn_link || "javascript:;"} onClick={handleLinkClick}>
                          {section.button}
                        </Link>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )})}

          </div>
        </div>
      </div>

      {/* Desktop Header */}
      <header className="header">
        <div className="container position-relative">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-5 d-none d-lg-block">
              <div className="menu-wrap d-flex">
                <ul className="d-flex align-items-center">
                  {desktopNav.map((item) => (
                    <NavItem key={item.id_menu ?? item.id_custom_menu} item={item} />
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-4 col-lg-2">
              <div className="headerlogo">
                <Link className="logo d-block" to={LinkLang("/")}>
                  {site_settings.head_logo ? (
                    <img src={site_settings.head_logo} alt="Logo" width={109} height={38} className="w-100 header-logo-image" />
                  ) : (
                   <svg xmlns="http://www.w3.org/2000/svg" width="138" height="48" viewBox="0 0 138 48" fill="none">
                      <path d="M33.3087 6.42846C32.7364 5.94573 32.0912 5.55688 31.3971 5.2766C30.8093 5.03768 30.1821 4.91115 29.5475 4.9038C28.8874 4.8736 28.2359 5.06163 27.6933 5.43905C27.2354 5.75878 26.9668 6.2856 26.9766 6.84398C26.9627 7.20643 27.0911 7.55991 27.335 7.82849C27.6068 8.11312 27.9314 8.34196 28.2906 8.50224C28.7135 8.70088 29.1535 8.86061 29.6049 8.98034C30.0828 9.11885 30.5606 9.27178 31.0387 9.42933C32.95 10.0666 34.3487 10.9173 35.2344 11.9815C36.1629 13.1663 36.6361 14.6447 36.5678 16.1486C36.5825 17.2219 36.3844 18.2875 35.9847 19.2837C35.6034 20.1985 35.0203 21.0151 34.2785 21.6731C33.4774 22.3716 32.5427 22.9001 31.531 23.2261C30.341 23.6095 29.0964 23.7951 27.8463 23.7757C25.0065 23.7782 22.2372 22.8908 19.9277 21.238L22.4366 16.5165C23.2086 17.2251 24.0856 17.8104 25.0361 18.2513C25.8329 18.6167 26.6977 18.8105 27.5739 18.82C28.3442 18.8809 29.1083 18.645 29.7102 18.1604C30.1486 17.7881 30.4047 17.2445 30.4126 16.6695C30.4207 16.3653 30.3603 16.0632 30.2357 15.7854C30.0945 15.513 29.8896 15.2787 29.6384 15.1021C29.301 14.8605 28.9328 14.6645 28.544 14.519C28.0996 14.3375 27.5548 14.1415 26.9192 13.9217C26.1578 13.6827 25.4152 13.4183 24.6922 13.1285C23.9871 12.8523 23.3319 12.4634 22.7517 11.9766C22.1689 11.4803 21.6995 10.8642 21.3757 10.1703C21.0007 9.29899 20.823 8.35584 20.8546 7.40807C20.841 6.37159 21.0293 5.34245 21.4091 4.37808C21.7572 3.50024 22.2864 2.70566 22.9621 2.04606C23.6633 1.37856 24.4971 0.865627 25.4089 0.540723C26.4484 0.169015 27.5456 -0.0141177 28.6493 0.000848535C29.8305 0.0152706 31.0055 0.175818 32.1473 0.478681C33.3623 0.788619 34.5351 1.24441 35.6407 1.83571L33.3087 6.40914V6.42846Z" fill="#1C1C1C"/>
                      <path d="M46.3934 0.660645V12.909C46.3934 13.5638 46.3934 14.2375 46.465 14.9257C46.5058 15.5681 46.6576 16.1989 46.9142 16.7894C47.1651 17.3497 47.5757 17.8234 48.0946 18.1513C48.7864 18.5372 49.5736 18.7179 50.3646 18.6724C51.1508 18.72 51.9342 18.5391 52.6202 18.1513C53.1342 17.8177 53.5432 17.3456 53.8006 16.7894C54.0714 16.2022 54.2333 15.5706 54.2784 14.9257C54.3261 14.2375 54.35 13.5638 54.35 12.909V0.660645H60.1567V13.7406C60.1567 17.2449 59.3602 19.8033 57.7672 21.4153C56.174 23.0276 53.71 23.8336 50.3741 23.8336C47.0481 23.8336 44.5789 23.0276 42.9669 21.4153C41.3547 19.8033 40.5535 17.2449 40.5631 13.7406V0.660645H46.3934Z" fill="#1C1C1C"/>
                      <path d="M71.0335 23.1835H65.1792V0.660645H74.4934C77.02 0.660645 78.9569 1.31862 80.3044 2.63429C81.6522 3.95023 82.3243 5.80115 82.3213 8.18732C82.3213 10.5768 81.6489 12.4296 80.3044 13.7453C78.9602 15.0612 77.023 15.7173 74.4934 15.7143H71.0286V23.1835H71.0335ZM71.0335 10.9974H72.9736C75.1242 10.9974 76.1993 10.0608 76.1996 8.18732C76.1993 6.31409 75.1242 5.3791 72.9736 5.3821H71.0335V10.9974Z" fill="#1C1C1C"/>
                      <path d="M98.5407 5.62129H91.5828V9.38218H98.1538V14.3425H91.5828V18.2232H98.5407V23.1835H85.7285V0.660645H98.5407V5.62129Z" fill="#1C1C1C"/>
                      <path d="M121.804 23.1829H114.493L108.901 14.5188V23.1829H103.047V0.660021H112.156C113.277 0.637436 114.392 0.825467 115.444 1.21432C116.317 1.54031 117.107 2.05624 117.757 2.72455C118.362 3.35803 118.831 4.10961 119.133 4.93221C119.45 5.794 119.611 6.70477 119.611 7.62288C119.679 9.11243 119.241 10.5808 118.368 11.79C117.442 12.919 116.148 13.6853 114.713 13.955L121.804 23.1829ZM108.901 10.7291H110.005C110.947 10.7887 111.883 10.5369 112.667 10.0123C113.806 8.99352 113.903 7.2441 112.884 6.1053C112.816 6.02883 112.744 5.95645 112.667 5.88815C111.883 5.36351 110.947 5.11181 110.005 5.1714H108.901V10.7291Z" fill="#1C1C1C"/>
                      <path d="M11.9627 34.5331H23.5801C23.5861 35.6196 23.5365 36.7059 23.432 37.7876C23.3441 38.7147 23.1433 39.6279 22.8347 40.5065C22.4437 41.6336 21.869 42.6881 21.1332 43.6274C20.4276 44.5221 19.5743 45.2898 18.6102 45.8974C17.6235 46.5143 16.5511 46.9812 15.4273 47.2833C14.2408 47.6068 13.0158 47.7676 11.7858 47.7611C10.152 47.781 8.52998 47.4874 7.00695 46.896C5.61155 46.3535 4.34513 45.5249 3.28878 44.4636C2.23135 43.388 1.40657 42.106 0.86588 40.6978C0.272944 39.1503 -0.0203955 37.5043 0.00110147 35.8471C-0.0182186 34.1995 0.26995 32.5624 0.85173 31.0206C1.3848 29.6152 2.20876 28.3384 3.26974 27.2739C4.35003 26.2167 5.63713 25.3933 7.04995 24.8559C8.62304 24.2589 10.2946 23.9636 11.9771 23.9862C14.1366 23.9399 16.2703 24.4659 18.1609 25.5106C20.0156 26.6148 21.4856 28.2633 22.3711 30.232L16.818 32.5306C16.4278 31.4625 15.7252 30.5368 14.8014 29.8737C13.9608 29.3303 12.9777 29.0492 11.9771 29.066C11.1553 29.0497 10.3398 29.2127 9.58768 29.5439C8.87801 29.8682 8.25079 30.3485 7.75255 30.9488C7.22056 31.5989 6.81538 32.3431 6.55769 33.1423C6.25619 34.0678 6.10925 35.0365 6.12285 36.0098C6.11496 36.9089 6.24041 37.8044 6.49565 38.6668C6.72368 39.4423 7.10546 40.1639 7.61866 40.7887C8.11936 41.3887 8.75256 41.8647 9.46823 42.1792C10.2818 42.5183 11.1581 42.681 12.0392 42.657C12.6024 42.6579 13.1638 42.592 13.7118 42.4611C14.2226 42.3381 14.7078 42.1264 15.1453 41.8353C15.5756 41.5433 15.9375 41.1618 16.2063 40.7169C16.504 40.2026 16.6956 39.6339 16.7701 39.0442H11.9627V34.5042V34.5331Z" fill="#1C1C1C"/>
                      <path d="M39.2492 43.2209H30.8864L29.5435 47.1347H23.2974L31.8706 24.6167H38.2647L46.8333 47.1347H40.5921L39.2492 43.2209ZM37.6963 38.7715L35.0679 31.2734L32.4393 38.7715H37.6963Z" fill="#1C1C1C"/>
                      <path d="M55.2583 24.6123V42.1748H62.2786V47.1352H49.4043V24.6123H55.2583Z" fill="#1C1C1C"/>
                      <path d="M71.1479 24.6123V42.1748H78.1682V47.1352H65.2939V24.6123H71.1479Z" fill="#1C1C1C"/>
                      <path d="M93.9958 29.5727H87.0376V33.3338H93.6086V38.2942H87.0376V42.1748H93.9958V47.1352H81.1836V24.6123H93.9958V29.5727Z" fill="#1C1C1C"/>
                      <path d="M116.949 47.1347H109.647L104.065 38.4755V47.1347H98.2061V24.6167H107.319C108.439 24.5931 109.552 24.7795 110.602 25.1664C112.322 25.798 113.674 27.1597 114.292 28.8843C114.611 29.7453 114.773 30.6566 114.77 31.5747C114.837 33.0634 114.401 34.5312 113.532 35.7419C112.602 36.8692 111.307 37.6352 109.871 37.9068L116.949 47.1347ZM104.065 34.6809H105.169C106.11 34.7421 107.044 34.4899 107.826 33.9641C108.965 32.9532 109.069 31.2103 108.057 30.0713C107.985 29.9896 107.908 29.9124 107.826 29.84C107.044 29.3143 106.11 29.062 105.169 29.1232H104.065V34.6809Z" fill="#1C1C1C"/>
                      <path d="M123.745 36.3206L115.535 24.6123H122.521L126.703 30.7675L130.856 24.6123H137.843L129.599 36.3206V47.1352H123.745V36.3206Z" fill="#1C1C1C"/>
                    </svg>
                  )}
                </Link>
              </div>
            </div>

              <div className="col-8 col-md-5">
              <div className="right-wrap d-flex align-items-center justify-content-end justify-content-lg-between careerFilter">
                <div className="header-search position-relative">
                  <form
                    className="d-none d-lg-block"
                    onSubmit={handleSearchSubmit}
                    ref={searchRef}
                  >
                    <div className="form-group mb-0">
                      <input
                        type="text"
                        name="search"
                        placeholder={__("Search for a photographer")}
                        required
                        autoComplete="off"
                        onChange={(e) => {
                          setQuery(e.target.value);
                          setIsOpen(true);
                        }}
                        className="form-control"
                      />
                      <svg
                        onClick={handleSearchSubmit}
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
                          stroke="#1C1C1C"
                          strokeWidth="1.5"
                          strokeLinecap="square"
                        />
                      </svg>
                    </div>
                  </form>

                  {isOpen && (loading || results.length > 0 || query.length > 1) && (
                    <div
                      className="position-absolute suggestions w-100 shadow-sm"
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {loading && <div className="text-center p-3 text-muted">Searching...</div>}
                      {!loading && results.length === 0 && query.length > 1 && (
                        <div className="text-center p-3 text-muted">No products found</div>
                      )}
                      {!loading && results.length > 0 && (
                        <ul className="list-unstyled mb-0">
                          {results.map((item) => (
                            <li key={item.id}>
                              <div
                                className="row align-items-center"
                                onClick={handleLinkClick}
                                onMouseDown={() => {
                                  navigate(`${item.slug}`);
                                  setIsOpen(false);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="col-4 col-md-4">
                                  <figure className="p-0 m-0">
                                    <img src={item.image} alt={item.name} className="w-100" />
                                  </figure>
                                </div>
                                <div className="col-8 col-md-8">
                                  <article className="d-flex justify-content-between align-items-start flex-wrap flex-md-nowrap">
                                    <span className="text-dark">{item.name}</span>
                                  </article>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                </div>

                <div className="header-icons">
                  <ul className="d-flex align-items-center justify-content-end justify-content-lg-between">
                    <li className="menuDrop cartMenu profileMenu">
                      {isAuthenticated ? (
                        <>
                          <button className="icons border-0 bg-transparent p-0" aria-expanded="false" aria-label={__("Open account menu")}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="square" />
                            </svg>
                          </button>
                          <div className="sub-menu drop-menu text-start h-auto">
                            <ul>
                              <li><Link to={LinkLang("/account")}>{__("Profile")}</Link></li>
                              <li><Link onClick={handleLogout}>{__("Logout")}</Link></li>
                            </ul>
                          </div>
                        </>
                      ) : (
                        <Link className="icons" to={LinkLang("/signup")} aria-label={__("Sign in or create an account")}>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="square" />
                          </svg>
                        </Link>
                      )}
                    </li>

                    <li>
                      <Link to={LinkLang("/wishlist")} className="icons cart_icon" aria-label={__("Open wishlist")}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="square" />
                        </svg>
                        {wishlist.count > 0 && <span className="cart-count-badge">{wishlist.count}</span>}
                      </Link>
                    </li>

                    <li className="menuDrop cartMenu">
                      <Link to={LinkLang("checkout")} className="icons cart_icon" onClick={() => setIsOpen(!isOpen)} aria-label={__("Open shopping cart")}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.0004 9V6C16.0004 3.79086 14.2095 2 12.0004 2C9.79123 2 8.00037 3.79086 8.00037 6V9M3.59237 10.352L2.99237 16.752C2.82178 18.5717 2.73648 19.4815 3.03842 20.1843C3.30367 20.8016 3.76849 21.3121 4.35839 21.6338C5.0299 22 5.94374 22 7.77142 22H16.2293C18.057 22 18.9708 22 19.6423 21.6338C20.2322 21.3121 20.6971 20.8016 20.9623 20.1843C21.2643 19.4815 21.179 18.5717 21.0084 16.752L20.4084 10.352C20.2643 8.81535 20.1923 8.04704 19.8467 7.46616C19.5424 6.95458 19.0927 6.54511 18.555 6.28984C17.9444 6 17.1727 6 15.6293 6L8.37142 6C6.82806 6 6.05638 6 5.44579 6.28984C4.90803 6.54511 4.45838 6.95458 4.15403 7.46616C3.80846 8.04704 3.73643 8.81534 3.59237 10.352Z" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="square" />
                        </svg>
                        {cart?.products?.length > 0 && <span className="cart-count-badge">{cart.products.length}</span>}
                      </Link>

                      <div className="sub-menu drop-menu text-start">
                        <div className="menuWrap">
                          {(!cart?.products || cart.products.length === 0) && (
                            <div className="emptyBag text-center">
                              <span className="d-block mb-3"><i className="icons icon-bag"></i></span>
                              <p><strong>{__("You currently dont have any items in your bag")}</strong></p>
                              <Link to={LinkLang("/shop")} className="btn w-100" onClick={() => setIsOpen(false)}>
                                {__("Shop Now")}
                              </Link>
                            </div>
                          )}
                          {cart?.products?.length > 0 && (
                            <>
                              <h4 className="cart-title">{__("My Bag")}</h4>
                              <ul>
                                {cart.products.map((item, index) => {
                                  const price = item.discount_price || item.price;
                                  return (
                                    <li key={index}>
                                      <Link
                                        to={LinkLang(`/${item.category}/${item.link_rewrite}.html`)}
                                        className="d-flex flex-wrap align-items-center gap-3"
                                        onClick={() => setIsOpen(false)}
                                      >
                                        <figure>
                                          <img
                                            src={item.images?.[0]?.bySize?.cart_default?.url || item.default_image?.bySize?.cart_default?.url}
                                            alt={item.name}
                                          />
                                        </figure>
                                        <div className="description">
                                          <h6>{item.name} <b>({item.quantity_wanted})</b></h6>
                                          {item.attributes && Object.keys(item.attributes).length > 0 && (
                                            <p className="mb-2">({Object.values(item.attributes).join(", ")})</p>
                                          )}
                                          <ol>
                                            <li>
                                              <strong>{price}</strong>
                                              {item.discount_price && (
                                                <del style={{ marginLeft: "10px" }}><strong>{item.price}</strong></del>
                                              )}
                                            </li>
                                          </ol>
                                        </div>
                                      </Link>
                                      <button
                                        className="remove-btn"
                                        aria-label={`${__("Remove")} ${item.name}`}
                                        onClick={(e) => { e.preventDefault(); handleRemove(item); }}
                                      ></button>
                                    </li>
                                  );
                                })}
                              </ul>
                              <div className="emptyBag p-3 text-center">
                                <Link className="btn w-100" to={LinkLang("/checkout")} onClick={() => setIsOpen(false)}>
                                  {__("Checkout")}
                                </Link>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </li>

                    <li className="d-block d-lg-none">
                      <Link href="javascript:;" className="burgermenu text-end" data-bs-toggle="offcanvas" data-bs-target="#mainMenu" aria-label={__("Open menu")}>
                        <svg width="30" height="30" viewBox="0 0 72 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L71 0.999994" stroke="#1C1C1C" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M1 18.5L71 18.5" stroke="#1C1C1C" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M1 36L71 36" stroke="#1C1C1C" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="form-group ct-slct mb-0">
                  <div className="child_option position-relative">
                    <button
                      className="form-control open-menu2 text-start d-flex align-items-center justify-content-between"
                      type="button"
                      onClick={(e) => e.preventDefault()}
                    >
                      {site_settings.languages?.find(
                        (l) => Number(l.id_lang) === Number(site_settings.current_lang_id)
                      )?.name || "Select Language"}
                      <svg className="ms-2" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.6" d="M1 1L7 7L13 1" stroke="#222222" strokeLinecap="round" />
                      </svg>
                    </button>
                    <div className="dropdown-menu2 dropdown-menu-right">
                      <ul className="careerFilterInr">
                        {site_settings.languages &&
                          site_settings.languages
                            .filter((lang) => Number(lang.id_lang) !== Number(site_settings.current_lang_id))
                            .map((lang) => (
                              <li key={lang.id_lang}>
<a
  href="#"
  className="dropdown_select"
 onClick={(e) => {
    e.preventDefault();

    let currentPath = window.location.pathname;

    // const BASE_PATH = ";

    // Browser pathname se basename remove karo
    if (currentPath.startsWith(BASE_PATH)) {
        currentPath =
            currentPath.substring(BASE_PATH.length) || "/";
    }

    const segments = currentPath
        .split("/")
        .filter(Boolean);

    const currentLang = segments[0];

    if (languages.some(item => item.code === currentLang)) {
        segments[0] = lang.iso_code;

        navigate("/" + segments.join("/"));
    } else {
        navigate(
            `/${lang.iso_code}${currentPath === "/" ? "" : currentPath}`
        );
    }
}}
>
  {lang.name}
</a>
                              </li>
                            ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
